export default from './reg-item-card-ghost'
